export default __webpack_public_path__ + "static/tree-cameraRaw-hardMix-h348-16c74f3ed87cc79f7dd507750a958418.png";